$(document).ready(function() {
    $('.js-bnt-toggle').on('click', function() {
        $('#' + $(this).attr('data-toexpand')).toggleClass('expand'); // Add to attr list
        $(this).toggleClass('collapsed'); // Add to button
    });
});